import { db } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { StockType } from 'types/stock'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'

const modifyStockAmountToZero = (stocks: StockType[]) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    const batch = db.batch()
    for (let i = 0; i < stocks.length; i = (i + 1) | 0) {
      const stock = stocks[i]
      if (!stock.stock_ref) continue
      batch.update(stock.stock_ref, { stock: 0 })
    }
    return batch
      .commit()
      .then(() => {
        dispatch(hideLoadingAction())
      })
      .catch((error) => {
        dispatch(hideLoadingAction())
        console.error(error)
      })
  }
}

export default modifyStockAmountToZero
